<template>
    <div class="templete">
        <div class="btnList clearfix">
            <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.indexOf(',finance-account-manage-edit,')!=-1" @click="dialogVisible = !dialogVisible;updataType=2">新增账户</el-button>
            <el-button class="funcPublicBtn" v-if="module.indexOf(',finance-account-manage-edit,')!=-1" @click="dialogVisibleCost = !dialogVisibleCost;costType=0;bill_type_name='收入';selectRow.length==1?cost_params.account_id = selectRow[0].id:'';">其它收入</el-button>
            <el-button class="funcPublicBtn" v-if="module.indexOf(',finance-account-manage-edit,')!=-1" @click="dialogVisibleCost = !dialogVisibleCost;costType=1;bill_type_name='支出';selectRow.length==1?cost_params.account_id = selectRow[0].id:'';">其他支出</el-button>
            <el-button class="funcPublicBtn" v-if="module.indexOf(',finance-account-manage-edit,')!=-1" @click="dialogVisibleCost = !dialogVisibleCost;costType=2;bill_type_name='转账';cost_params.course_title='内部资金转账';cost_params.remark='转账';selectRow.length==1?cost_params.account_id = selectRow[0].id:'';">资金转账</el-button>
        </div>
        <div class="tableBox">
            <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @statusClick="statusClick" @getRow="getRow" @rowClick="rowClick" @getTableDelete="del" @getTableEdit="edit"></tabletem>
        </div>
        <div class="totalCal no_print">
            <div class="totalNumber" >合计：</div>
            <div class="totalNumber" >账户数量：{{totalObj.count}}</div>
            <div class="totalNumber" >账户余额：{{totalObj.balance}}</div>
        </div>
        <!-- 添加|修改 供应商 START -->
        <el-dialog v-dialog-drag :title="updataType==2?'添加账户':'修改账户'" :visible.sync="dialogVisible" class="eldialog eldialogLine" :model="false">
            <el-form :model="form_params" :rules="rules" ref="edit_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox accountDialog">
                    <el-form-item label="账户名称：" prop="name">
                        <el-input v-model="form_params.name" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="卡号：">
                        <el-input v-model="form_params.bank_no" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="户名：">
                        <el-input v-model="form_params.account_name" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="开户行：">
                        <el-input v-model="form_params.bank_name" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="初始金额：">
                        <el-input v-model="form_params.first_balance" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item class="accountDialogItem" label="收款码：">
                        <div class="uploadCode">
                            <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG">
                                <img v-if="form_params.pay_url" :src="form_params.pay_url" class="uploadImage"/>
                                <img v-if="!form_params.pay_url" src="/icon/plus-default@2x.png" class="uploadImageAdd"/>
                                <!-- <div class="el-upload__text"  style="font-size:12px; color:#333;">将文件拖到此处，或<em style="color: #b21111;">点击上传</em></div> -->
                                <!-- <div class="el-upload__tip" slot="tip"  style="color: #888;margin-top:20px;">只能上传Excel文件</div> -->
                            </el-upload>
                            <div v-if="form_params.pay_url" class="deleteIcon" @click.stop="deleteQrcode"><i class="el-icon-delete"></i></div>
                        </div>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisible = false">取消</el-button>
                <el-button  class="publicBtn dialogBtn"  @click="add">确定</el-button>
            </div>
        </el-dialog>
        <!-- 添加|修改 供应商 END -->
        <!-- dialogVisibleCost START -->
        <el-dialog v-dialog-drag :title="costType==0?'其它收入':costType==1?'其它支出':'资金转账'" :visible.sync="dialogVisibleCost" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="cost_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item :label="costType==2?'转出账户：':'我方账户：'">
                        <el-select v-model="cost_params.account_id" placeholder="" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="costType==2" label="转入账户：">
                        <el-select v-model="cost_params.customer_id" placeholder="" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="costType!=2" label="客户名称：">
                        <el-input v-model="cost_params.customer_name"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="销售单号：">
                        <el-input v-model="cost_params.order_sn"></el-input>
                    </el-form-item> -->
                    <el-form-item label="流水类型：">
                        <el-input v-model="bill_type_name" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="交易方式：">
                        <el-select v-model="cost_params.payment_type_id" placeholder="" @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="科目名称：">
                        <el-input v-model="cost_params.course_title" :readonly="costType==2" placeholder="科目名称"></el-input>
                    </el-form-item>
                    <el-form-item label="交易RMB金额：">
                        <el-input v-model="cost_params.amount" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="cost_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="dialogVisibleCost=!dialogVisibleCost">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="costConfirm">确定</el-button>
            </div>
        </el-dialog>
        <!-- dialogVisibleCost END -->
    </div>
    
</template>
<style scoped lang="scss">
    .uploadImage{width:100px;height:100px;}
    .uploadImageAdd{width:35px;height: 35px;margin:auto;margin-top:32.5px;}
    .uploadCode{width: 102px;height: 102px;position: relative;}
    .uploadCode:hover .deleteIcon{display: flex;}
    .deleteIcon{position: absolute;right: 0;top: 0;z-index: 10;width: 102px;height: 102px;background: #B21111;opacity: 0.7; display: none;align-items: center;justify-content: center;border-radius: 6px;color: #fff;cursor: pointer;}
    .deleteIcon>i{display: flex;align-items: center;justify-content: center;width: 25px;height: 25px;border-radius: 50%;background: #fff;color: #B21111;font-size: 14px;}
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
        .filter_path{
            padding: 15px; background-color: #F4F5F9;
            .filter_input{
                width: 120px;
                & + .filter_input{ margin-left: 34px; }
            }
        }
        .operate_row{
            display: flex; align-items: center; justify-content: space-between; padding: 28px 0 8px;
        }
        .table_path{ flex: 1; }
        /* // dialog */
        .dialog_hr{ position: absolute; left: 10px; right: 10px; top: 56px; margin: 0; }
        .edit_form{
            display: flex; align-items: center;
            & > div{ flex: 1; }
            .edit_input{ width: 160px; }
        }
    }
</style>
<script>
    import tabletem from '../../components/table.vue'
    export default {
        components:{
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                updataType:2,//2新增，3修改
                list:[],
                totalObj:{},
                imageUrl:"",
                tableCol:[	
                    {colName:"账户名称",colKey:"name",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"卡号",colKey:"bank_no",colWidth:170,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"户名",colKey:"account_name",colWidth:170,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"开户行",colKey:"bank_name",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"初始金额",colKey:"first_balance",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"当前余额",colKey:"balance",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"二维码",colKey:"pay_url",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isImg:true},
                    {colName:"流水明细",colKey:"detail",colWidth:90,isSetWidth:true,isCanClick:true,isShow:true,isColor:true},
                    {colName:"状态",colKey:"status",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isStatus:true}
                ],
                saleList:[],
                // dialog
                dialogVisible : false,
                dialogVisibleCost:false,
                bill_type_name:"",
                form_params : {
                    name:"",
                    first_balance:"",
                    bank_name:"",
                    bank_no:"",
                    account_name:"",
                    pay_url:""
                },
                costType:"",//0其他收入，1其他支出，2资金转账
                trading_time:new Date(),
                cost_params:{
                    bill_type:"",//流水类型，0其他收入，1其他支出），2资金转账
                    payment_type_id:"",
                    trading_time:"",
                    account_id:"",
                    customer_name:"",
                    course_title:"",
                    amount:"",
                    remark:"",
                    customer_id:"",
                    order_sn:""
                },
                rules: {
                    name : [ { required: true, message: '请输入账户名称', trigger: 'blur' } ],
                    first_balance : [ { required: true, message: '请选择初始金额', trigger: 'blur' } ],
                    bank_name : [ {required: true,  message: '请输入开户行', trigger: 'blur' } ],
                    bank_no : [ { required: true, message: '请输入卡号', trigger: 'blur' } ],
                    account_name : [ {required: true,  message: '请输入户名', trigger: 'blur' } ]
                },
                upload_data : {},
				oss : {
                    host : "",
                },
                file_url : '',
                selectMap:{
                    account:[],
                    customer:[],
                    paymentType:[]
                },
                selectRow:[]
            }
        },
        created(){
            this.getSelectList("account")
            this.getList();
        },
        methods:{
            statusClick(obj){
                let mess = "";
                if(obj.status == 1){
                    obj.status = 0;
                    mess = "是否禁用？"
                }else{
                    obj.status = 1;
                    mess = "是否启用？"
                }
                this.$confirm(mess, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    this.postFuncLoading("/erp/account.status",obj,()=>{
                        this.tip("操作成功","success")
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            rowClick(obj){
                if(obj.name=="detail"){
                    sessionStorage.removeItem("DEMU_ERP_PURCHASE_FLOWDETAIL_ACCOUNT")
                    sessionStorage.setItem("DEMU_ERP_PURCHASE_FLOWDETAIL_ACCOUNT",obj.id)
                    this.$root.$children[0].$children[0].addTab({
                        name: '流水明细'+obj.id,
                        label: '流水明细',
                        content: 'financeFlowDetail'
                    });
                }
            },
            getRow(row){
                this.selectRow=row;
            },
            costConfirm(){
                this.cost_params.bill_type = this.costType;
                this.cost_params.trading_time = this.trading_time;
                this.cost_params.trading_time = this.formatTimeZero(this.cost_params.trading_time)
                this.postFuncLoading("/erp/finance.inout",this.cost_params,()=>{
                    this.dialogVisibleCost = false;
                    this.getList()
                    this.tip("提交成功","success")
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            del(id){
                this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    this.postFuncLoading("/erp/account.delete",{id:id},()=>{
                        this.tip("删除成功","success")
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            edit(id){
                this.dialogVisible=true;
                this.updataType=3;
                this.list.forEach(item=>{
                    if(item.id==id){
                        let editList=JSON.parse(JSON.stringify(item));
                        if(item.province_id!=0){
                            this.getArea(item.province_id).then(res=>{
                                this.cityList=res.data.data;
                            })
                        }
                        this.form_params=editList;
                    }
                })
            },
            getList(){
                this.postFunc("/erp/account.list",this.params,res=>{
                    this.list=res.data.data.list; 
                    this.totalObj = res.data.data.total;
                    this.list.forEach(item=>{
                        item.isDelete = true;
                        item.isEdit = true;
                        item.detail = "流水明细";
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            add(){
                this.$refs["edit_form"].validate((valid) => {
					if (valid) {
                        if(this.updataType==2){
                            this.postFuncLoading("/erp/account.create",this.form_params,()=>{
                                this.tip("添加成功","success");
                                this.getList();
                                this.form_params = this.resetJson(this.form_params)
                                this.dialogVisible=false;
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }else{
                            this.postFuncLoading("/erp/account.update",this.form_params,()=>{
                                this.tip("修改成功","success")
                                this.getList();
                                this.dialogVisible=false;
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }
					} else {
						return false;
					}
				});
            },
            handleSuccess(res) {
                this.form_params.pay_url = res.data.base_url;
                this.$refs.upload_path.clearFiles();
                this.tip('文件上传成功', 'success');
                //this.importFile();
            },
            deleteQrcode(){
                this.form_params.pay_url = "";
                this.$refs.upload_path.clearFiles();
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },
            importFile(){
                this.analysis('/erp/import.analysis',this.file_url,this.info.tpl_code,this.info.purchase_id,"",response=>{
                    if (response.data.code == 0) {
                        this.tip("上传成功","success")
                        this.getDetailList()
                        this.importDialogVisible=false;
                    }else{
                        this.tip(response.data.message,"warning")
                    }
                })
            },
            getOss(){
                let self = this;
                return new Promise((resolve, reject) =>{
                    window.axios.post(window.oss_url+"/tool/v1/oss.policy.get",{
                        operate_code : "shop-excel"
                    }).then((response) => {
                        if(response.data.code == 0){
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key : self.oss.dir + "${filename}",
                                policy : self.oss.policy,
                                OSSAccessKeyId : self.oss.accessid,
                                success_action_status : "200",
                                callback : self.oss.callback,
                                signature : self.oss.signature,
                                'Cache-Control' : self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(()=>{
                        reject();
                    })
                })
            }
        },
        watch:{
            dialogVisible:function(val){
                if(!val){
                    this.form_params = this.resetJson(this.form_params)
                }
            },
            dialogVisibleCost:function(val){
                if(!val){
                    this.trading_time = new Date();
                    this.cost_params = this.resetJson(this.cost_params)
                }
            }
        }
    }
</script>
